/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * Enumeration to define what parts of the person component render
 *
 * @export
 * @enum {number}
 */
export var ViewType;
(function (ViewType) {
    /**
     * Render only the avatar
     */
    ViewType[ViewType["image"] = 2] = "image";
    /**
     * Render the avatar and one line of text
     */
    ViewType[ViewType["oneline"] = 3] = "oneline";
    /**
     * Render the avatar and two lines of text
     */
    ViewType[ViewType["twolines"] = 4] = "twolines";
    /**
     * Render the avatar and three lines of text
     */
    ViewType[ViewType["threelines"] = 5] = "threelines";
})(ViewType || (ViewType = {}));
//# sourceMappingURL=types.js.map